import { configureStore, combineReducers } from '@reduxjs/toolkit';

import contact from './contact';
import campaign from './campaign';
import recipe from './recipe';
import cta from './cta';
import story from './stories';
import approval from './approval';
import assigned from './assigned';
import reply from './reply';
import scheduled from './scheduled';
import sent from './sent';
import storyteller from './storyteller';
import storyTemplate from './storyTemplate';
import sharedVideo from './sharedVideo';
import video from './video';
import tag from './tag';
import workspace from './workspace';
import auth from './auth';
import audience from './audience';
import automation from './automations';
import teams from './teams';
import inbox from './inbox';
import chatbot from './chatbot';
import groups from './groups';
import userTemplates from './userTemplates';
import inquiryFormTemplates from './inquiryFormTemplates';
import inquiry from './inquiry';
import activity from './activity';
import contactAttributes from './contactAttributes';
import funnel from './funnel';
import personalizationSettings from './personalizationSettings';
import prebuiltCampaign from './prebuiltCampaign';

import fetchMiddleware from './fetch-middleware';
import overlays from './overlays';
import { useAppDispatch } from './types';

import personalization from './personalization';

export const storeReducers = combineReducers({
	activity,
	approval,
	assigned,
	audience,
	auth,
	automation,
	campaign,
	chatbot,
	contact,
	contactAttributes,
	cta,
	funnel,
	groups,
	inbox,
	overlays,
	personalization,
	prebuiltCampaign,
	recipe,
	reply,
	scheduled,
	sent,
	sharedVideo,
	story,
	storyTemplate,
	storyteller,
	tag,
	teams,
	userTemplates,
	inquiryFormTemplates,
	inquiry,
	video,
	workspace,
	personalizationSettings,
});

const CLEAR_ALL_EXCEPT_AUTH = 'CLEAR_ALL_EXCEPT_AUTH';

const rootReducer = (state: any, action: any) => {
	if (action.type === CLEAR_ALL_EXCEPT_AUTH) {
		const copyAuthState = state.auth;
		state = {};
		state.auth = copyAuthState;
	}
	return storeReducers(state, action);
};

const store = configureStore({
	reducer: rootReducer,
	middleware: (getDefaultMiddleware1) =>
		getDefaultMiddleware1({
			serializableCheck: false,
			immutableCheck: false,
		}).concat(fetchMiddleware),
});

export default store;
export { useAppDispatch };

export const clearAllExceptAuth = () => {
	return {
		type: CLEAR_ALL_EXCEPT_AUTH,
	};
};
